import { FileUpload } from '@assets/svgs';
import { Button } from '@components/button';

// TODO update styling and change to a variant of button

export const UploadFileButton = ({ onClick, disabled = false }: { onClick: () => void; disabled: boolean }) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant='outlined'
      sx={{
        margin: '0',
        alignSelf: 'flex-start',
        padding: '8px 16px !important',
      }}
      startIcon={<FileUpload width='14px' height='14px' />}
    >
      Upload
    </Button>
  );
};
